import { render, staticRenderFns } from "./NpRecognitionCategoryEdit.vue?vue&type=template&id=49eb267f&scoped=true"
import script from "./NpRecognitionCategoryEdit.vue?vue&type=script&lang=js"
export * from "./NpRecognitionCategoryEdit.vue?vue&type=script&lang=js"
import style0 from "./NpRecognitionCategoryEdit.vue?vue&type=style&index=0&id=49eb267f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eb267f",
  null
  
)

export default component.exports